// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { sagaMiddleware, store } from "states/store";
import { RootPath } from "types";
import mySaga from "sagas/sagas";
import { CloudSagas } from "sagas/cloudsagas";

import IntlProvider from "view/comp/IntlProvider";
import Root from "view/layout/Root";
import { childRoutes } from "view/layout/ContentPanel";

function startApplication() {
  // get routes
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      errorElement: <h1>This site is not available.</h1>,
      children: childRoutes,
    },
    {
      path: `/${RootPath.RFID}`,
      element: <Root />,
      errorElement: <h1>This rfid page is not available.</h1>,
      children: childRoutes,
    },
    {
      path: `/${RootPath.OCPP}`,
      element: <Root />,
      errorElement: <h1>This ocpp page is not available.</h1>,
      children: childRoutes,
    },
    {
      path: `/${RootPath.TREND}`,
      element: <Root />,
      errorElement: <h1>This trend page is not available.</h1>,
      children: childRoutes,
    },
  ]);
  // add router to saga
  sagaMiddleware.setContext({
    router,
  });

  const container = document.getElementById("root");
  const root = createRoot(container!);
  root.render(
    <Provider store={store}>
      <IntlProvider>
        <RouterProvider router={router} />
      </IntlProvider>
    </Provider>,
  );

  // run the saga
  const apiSagas = new CloudSagas();
  sagaMiddleware.run(mySaga.bind(null, store, apiSagas));
}

// main entry point
startApplication();
